import { KeyboardProvider } from './KeyboardProvider';
import { ChatProvider } from '@agently/components/chat-core';
import { QueryProvider } from './QueryProvider';

import { useUser } from 'auth';

const AppProviders = ({ children }: { children: React.ReactNode }) => {
  const user = useUser();
  return (
    <QueryProvider>
      <KeyboardProvider>
        <ChatProvider
          chatTokenId={user?.chatToken || null}
          chatUserId={user?.chatUserId || null}
        >
          {children}
        </ChatProvider>
      </KeyboardProvider>
    </QueryProvider>
  );
};

export default AppProviders;
